import ZoneItem from '@/dto/Zone/ZoneItem'

export default function ZoneItemFactory(zoneItem: ZoneItem) {
  const state = zoneItem.state || {}
  const country = zoneItem.country || {}
  const city = zoneItem.city || {}

  return {
    id: zoneItem.id || null,
    state: {
      id: state.id || null,
      name: state.name || null,
    },
    country: {
      id: country.id || null,
      name: country.name || null,
    },
    city: {
      id: city.id || null,
      name: city.name || null,
    },
    maxTerm: zoneItem.maxTerm || 0,
    minTerm: zoneItem.minTerm || 0,
    maxWeight: zoneItem.maxWeight || 0,
    maxHeight: zoneItem.maxHeight || 0,
    maxWidth: zoneItem.maxWidth || 0,
    maxLength: zoneItem.maxLength || 0,
  }
}
